import format from "date-fns/format";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import { ADD_TO_BASKET_URL } from "../../../api/apiRoutes";
import { setBasketItemLimited } from "../../../models/BasketItem";
import useFacility from "../../../../utils/hooks/useFacility";
import { canSendToGTM } from "../../../../utils/Analitics/analiticsConfigByFacility";
import { sendAddToCartEvent } from "../../../../utils/Analitics/GtmEvents";

export default function useCustomHooks() {
  const { post } = useApiRequest();
  const facilityIds = useFacility();

  const addGuideToBasket = async (ids: number, qnt: number) => {
    const formattedDate = format(new Date(), "yyyy-MM-dd");
    const basketItem = setBasketItemLimited(facilityIds, `0,+${ids}`, formattedDate, qnt, []);

    await post(ADD_TO_BASKET_URL, {
      ...basketItem,
    });

    // Wysyłanie eventu GTM add_to_cart
    if (canSendToGTM(facilityIds)) {
      sendAddToCartEvent(facilityIds, {
        currency: "PLN",
        items: [
          {
            item_id: ids.toString(),
            item_name: "Przewodnik",
            quantity: qnt,
          },
        ],
      });
    }
  };

  return {
    addGuideToBasket,
  };
}
